import { FaClipboardList, FaMotorcycle } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import Permission from "../../../common/components/auth/Permission";
import { MdHomeRepairService } from "react-icons/md";
import { CiStickyNote } from "react-icons/ci";
import { TbReportSearch } from "react-icons/tb";
import { BsClipboardCheck } from "react-icons/bs";
import { FaBox } from "react-icons/fa";
import { type ReactNode } from "react";

type ModuleCardProps = {
  icon: ReactNode;
  label: string;
  status: string;
  onClick: () => void;
};

const ModuleCard = ({ icon, label, status, onClick }: ModuleCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex items-center gap-4 bg-white rounded-[14px] px-5 py-4
      transition-all duration-200 cursor-pointer text-left w-full
      hover:-translate-y-0.5 hover:shadow-md"
    style={{
      border: "0.5px solid rgba(0,0,0,0.08)",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.borderColor = "rgba(224,51,51,0.3)";
      e.currentTarget.style.backgroundColor = "rgba(224,51,51,0.04)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.borderColor = "rgba(0,0,0,0.08)";
      e.currentTarget.style.backgroundColor = "#fff";
    }}
  >
    <div
      className="flex items-center justify-center shrink-0 rounded-xl text-[#e03333]"
      style={{
        width: 44,
        height: 44,
        backgroundColor: "rgba(224,51,51,0.10)",
        fontSize: 20,
      }}
    >
      {icon}
    </div>
    <div className="flex flex-col min-w-0">
      <span className="text-gray-800 leading-snug" style={{ fontSize: 13, fontWeight: 500 }}>
        {label}
      </span>
      <span className="text-gray-400 mt-0.5" style={{ fontSize: 11 }}>
        {status}
      </span>
    </div>
  </button>
);

const InventorySection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full p-6">
      <header className="w-full pb-4 mb-6 border-b border-gray-200">
        <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
          📦 Módulo de Estoque
        </h2>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        <Permission permission="view:categories">
          <ModuleCard
            icon={<FaMotorcycle />}
            label="Categorias"
            status="Grupos de veículos"
            onClick={() => navigate("/categorias")}
          />
        </Permission>

        <Permission permission="view:products">
          <ModuleCard
            icon={<FaClipboardList />}
            label="Catálogo de Produtos"
            status="Peças e insumos"
            onClick={() => navigate("/produtos")}
          />
        </Permission>

        <Permission permission="view:works">
          <ModuleCard
            icon={<MdHomeRepairService />}
            label="Serviços"
            status="Serviços cadastrados"
            onClick={() => navigate("/servicos")}
          />
        </Permission>

        <Permission permission="view:stocks">
          <ModuleCard
            icon={<FaBox />}
            label="Estoque"
            status="Controle de itens"
            onClick={() => navigate("/nfs")}
          />
        </Permission>

        <Permission permission="view:stocks">
          <ModuleCard
            icon={<CiStickyNote />}
            label="Retirada de Estoque"
            status="Saídas registradas"
            onClick={() => navigate("/retiradaDeEstoque")}
          />
        </Permission>

        <Permission permission="view:stocks">
          <ModuleCard
            icon={<TbReportSearch />}
            label="Ativo Imobilizado"
            status="Patrimônio da empresa"
            onClick={() => navigate("/controle-equipamentos")}
          />
        </Permission>

        <ModuleCard
          icon={<BsClipboardCheck />}
          label="Inventário de Estoque"
          status="Contagens e auditorias"
          onClick={() => navigate("/stock-inventario")}
        />
      </div>
    </section>
  );
};

export default InventorySection;
